<template>
  <label
    :for="id + '_button'"
    :class="[{ active: isActive }, activeColor]"
    class="toggle__button"
  >
    <template v-if="enableLable">
      <span v-if="isActive" class="toggle__label">{{ enableText }}</span>
      <span v-if="!isActive" class="toggle__label">{{ disabledText }}</span>
    </template>

    <input
      type="checkbox"
      :disabled="disabled"
      :id="id + '_button'"
      v-model="checkedValue"
    />
    <span class="toggle__switch"></span>
  </label>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    activeColor: {
      type: String
    },
    labelEnableText: {
      type: String,
      default: "On"
    },
    enableLable: {
      type: Boolean,
      default: false
    },
    labelDisableText: {
      type: String,
      default: "Off"
    },
    id: {
      type: String,
      default: "primary"
    },
    defaultState: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentState: this.defaultState
    };
  },
  watch: {
    defaultState: function defaultState() {
      this.currentState = Boolean(this.defaultState);
    }
  },
  computed: {
    // currentState() {
    //     return this.defaultState;
    // },
    isActive() {
      return this.currentState;
    },
    enableText() {
      return this.labelEnableText;
    },
    disabledText() {
      return this.labelDisableText;
    },
    checkedValue: {
      get() {
        return this.currentState;
      },
      set(newValue) {
        this.currentState = newValue;
        this.$emit("change", newValue);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/scss/custom";
@import "src/scss/custom/variables";
@import "bootstrap/scss/_functions.scss";
@import "bootstrap/scss/_variables.scss";
@import "bootstrap/scss/_mixins.scss";
.toggle__button {
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
  display: inline-flex;
  padding-right: 3px;
  padding-bottom: 2px;
  padding-top: 2px;
  margin-bottom: 0;
  @include media-breakpoint-up(md) {
    padding-right: 5px;
  }
}
.toggle__button input[type="checkbox"] {
  opacity: 0;
  position: absolute;
  width: 1px;
  height: 1px;
}
.toggle__button .toggle__switch {
  display: inline-block;
  height: 12px;
  width: 25px;
  background: #d6d9e9;
  box-shadow: inset 0 0 1px #d6d9e9;
  position: relative;
  margin-left: 10px;
  transition: all 0.25s;
  border-radius: 30px;
  @include media-breakpoint-up(md) {
    width: 35px;
    height: 16px;
  }
}
.toggle__button .toggle__switch::after,
.toggle__button .toggle__switch::before {
  content: "";
  position: absolute;
  display: block;
  height: 14px;
  width: 14px;
  border-radius: 50%;
  left: 0;
  top: -1px;
  transform: translateX(0);
  transition: all 0.25s cubic-bezier(0.5, -0.6, 0.5, 1.6);
  @include media-breakpoint-up(md) {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    left: -6px;
    top: -2px;
  }
}
.toggle__button .toggle__switch::after {
  background: #75838b;
  box-shadow: 0 0 1px #666;
}
.toggle__button .toggle__switch::before {
  background: #75838b;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
  opacity: 0;
}
.active .toggle__switch {
  background: #90e2f3;
  box-shadow: inset 0 0 1px #90e2f3;
}

.active .toggle__switch::after,
.active .toggle__switch::before {
  transform: translateX(40px - 18px);
}
.active .toggle__switch::after {
  left: -8px;
  background: #00cdf8;
  box-shadow: 0 0 1px #00cdf8;
  @include media-breakpoint-up(md) {
    left: 1px;
  }
}

/* danger */
.active.danger .toggle__switch {
  background: #ffaaaa;
  box-shadow: inset 0 0 1px #ffaaaa;
}
.active.danger .toggle__switch::after {
  background: #ff1d1d;
  box-shadow: 0 0 1px #ff1d1d;
}
</style>
